import yup from '@/init/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { InferType } from 'yup';

export const SearchPublicHomeSchema = yup.object({
  zipcode: yup.string(),
  filters: yup
    .object()
    .test(
      'is-valid-filters',
      'filters must be an object with boolean values',
      (value) => {
        if (!value || typeof value !== 'object') return false;
        return Object.values(value).every((v) => typeof v === 'boolean');
      },
    ),
  medical_subjects: yup.array(yup.number().required()).required(),
  reported_additional_fees: yup.array(yup.number().required()).required(),
  page: yup.number(),
});

export type SearchPublicHomeType = InferType<typeof SearchPublicHomeSchema>;
export const SearchPublicHomeResolver = yupResolver(SearchPublicHomeSchema);
